/**
 * Get the dimensions of a table by counting the children.
 *
 * Use this only as a fallback if you don't have the actual data available.
 */
export function getTableDimensions(props: any): {
    rows: number;
    columns: number;
} {
    if (Array.isArray(props.children) && props.children.length >= 2) {
        const tbody = props.children[1];

        // Ensure tbody exists and has props and children properties
        const rows = Array.isArray(tbody?.props?.children) ? tbody.props.children.length : 0;
        const columns = Array.isArray(tbody?.props?.children?.[0]?.children)
            ? tbody.props.children[0].children.length
            : 0;

        return { rows, columns };
    }

    // Fallback for unexpected structure
    return { rows: 0, columns: 0 };
}

/**
 * Set the page title with the Primepoint suffix.
 */
export function setPageTitle(title: string | undefined): void {
    document.title = title ? `${title} - Primepoint` : `Primepoint`;
}
